module.exports = __webpack_public_path__ + "img/rightemptyimage.0959441c.svg";